export const fileAttachmentQueryKeys = {
  base: ['fileAttachment'],
  fileAttachmentsForTenant: (tenantID: string | undefined | null) => [
    ...fileAttachmentQueryKeys.base,
    'fileAttachments',
    tenantID,
  ],
  fileAttachments: (tenantID: string | undefined | null, itemID: string | undefined | null) => [
    ...fileAttachmentQueryKeys.fileAttachmentsForTenant(tenantID),
    itemID,
  ],
};
